import { render, staticRenderFns } from "./FormVsdTagAlarmLimit.vue?vue&type=template&id=359fdff2&scoped=true"
import script from "./FormVsdTagAlarmLimit.vue?vue&type=script&lang=ts"
export * from "./FormVsdTagAlarmLimit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359fdff2",
  null
  
)

export default component.exports